import { Customer, ReservationExtent, useRepositoryQuery } from '@mews-commander/data-access';
import { keyById } from '@mews/fp';
import { getFullName } from '@mews-commander/utils';
import { EnrichedReservation } from './types';
import { getResourceName } from './utils';
import { useGetAllResourcesQuery } from './useGetAllResourcesQuery';

export const RESERVATIONS_EXTENT = {
    accounts: true,
    orderItems: false,
    products: false,
    reservationGroups: false,
    availabilityBlocks: false,
    companionships: false,
    businessSegments: false,
    generalNotes: false,
    channelManagerNotes: false,
    specialRequestNotes: false,
    vouchers: false,
    partnerCompanies: false,
    rates: false,
    travelAgencies: false,
    origin: false,
    bookingEngines: false,
    purchaseOrderNumbers: false,
} satisfies ReservationExtent;

export const useGetAllReservationsQuery = (ids: string[]): EnrichedReservation[] => {
    const { data: resourcesData } = useGetAllResourcesQuery();

    const { data } = useRepositoryQuery(
        'reservations',
        'getAll',
        { reservationIds: ids, extent: RESERVATIONS_EXTENT },
        {
            enabled: !!ids.length && !!resourcesData,
            select: (result) => {
                const accounts: Record<string, Customer> = keyById(result.accounts || []);

                return (result.reservations || []).map((reservation) => ({
                    ...reservation,
                    customerName: reservation.customerId ? getFullName(accounts[reservation.customerId]) : '',
                    resourceName: resourcesData
                        ? getResourceName(
                              reservation,
                              resourcesData.resources,
                              resourcesData.resourceCategories,
                              resourcesData.resourceCategoryAssignments
                          )
                        : '',
                }));
            },
        }
    );

    return data ?? [];
};
